/// <reference path="../_references.ts"/>
module App.Helpers {
	export type State = {
		name: string;
		abbreviation: string;
	}

	type States = {
		states: State[]
	}

	export class StatesService {
		constructor(public states: State[]){}

		public querySearch(query: string): State[] {
			return query ? this.states.filter(this.createFilterFor(query)) : this.states;
		}

		private createFilterFor(query: string):any {
			const lowercaseQuery = query.toLowerCase();

			return function filterFn(state: State) {
				return state.name.toLowerCase().indexOf(lowercaseQuery) === 0 ||
					state.abbreviation.toLowerCase().indexOf(lowercaseQuery) === 0;
			};
		}

		static factory() {
			let instance = (States: States) =>
				new StatesService(States.states);

			instance.$inject = ['States'];

			return instance;
		}
	}

	angular.module('helpers.statesService', [
		'helpers.states'
	]).factory('StatesService', StatesService.factory());
}
